<template>
  <v-footer
    id="footer"
    color="primary"
    app
  >
    <span class="white--text pl-2">&copy; CISS</span>
    <v-spacer class="mb-4 pb-4" />
    <span class="subtitle-2 mr-1">{{ envText }}</span>
    <span class="subtitle-2 white--text pr-2">{{ appName }} - version {{ currentVersion }}</span>
  </v-footer>
</template>

<script>
import { MetierEnv } from 'modulewebservice'
import { name, version } from '../../../package.json'

export default {
  name: 'Footer',

  data () {
    return {
      env: MetierEnv.getTypeEnv(),
      currentVersion: version,
      appName: name
    }
  },

  computed: {
    envText () {
      return this.env === MetierEnv.typeEnvEnum.INT
        ? 'INT - ' : this.env === MetierEnv.typeEnvEnum.DEV
          ? 'DEV - ' : ''
    }
  }
}
</script>
